export default function elementContains(containerElement, targetElement) {
    return containerElement?.contains?.(targetElement)
}